import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import Sentry from "./integrations/Sentry";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 10,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        if (
          isAxiosError(error) &&
          typeof error?.response?.status === "number" &&
          error.response.status >= 400 &&
          error.response.status < 500
        ) {
          return false;
        }
        if (failureCount >= 3) {
          return false;
        }
        return true;
      },
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      Sentry.captureException(error, {
        extra: {
          query,
        },
      });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, variables, context) => {
      Sentry.captureException(error, {
        extra: {
          variables,
          context,
        },
      });
    },
  }),
});

queryClient.setQueryDefaults(["permission"], { gcTime: Infinity });

export { queryClient };
